// import React from "react";
// import "./style/sidenav.css";
// import { assets } from "../../../assets/assets";
// import ar from "../../../lang/ar";
// import en from "../../../lang/en";
// function SideNav({
//   lang,
//   onLandmarksClick,
//   onRoadsClick,
//   showPlaces,
//   showRoads,
// }) {
//   const translations = lang === "ar" ? ar : en;
//   const allActive = showPlaces && showRoads ;
//   const filters = [
//     {
//       icon: assets.showall,
//       activeIcon: assets.showallActive,
//       label: translations.showAll,
//       type: "all",
//     },
//     {
//       icon: assets.landmarks,
//       activeIcon: assets.landmarksActive,
//       label: translations.landmarks,
//       type: "landmarks",
//     },
//     {
//       icon: assets.roads,
//       activeIcon: assets.roadsActive,
//       label: translations.roads,
//       type: "roads",
//     },
//     {
//       icon: assets.building_off,
//       activeIcon: assets.buildingActive,
//       label: translations.developers,
//       type: "devs",
//     },
//   ];

//   return (
//     <div
//       className={`side-nav d-none d-md-flex ${
//         lang === "ar" ? "right-side" : "left-side"
//       }`}
//     >
//       <p className="title">{translations.mapFilter}</p>

//       {filters.map((filter, index) => {
//         // 🔹 نحدد لو الزر مفعل
//         const isActive =
//           (filter.type === "landmarks" && showPlaces) ||
//           (filter.type === "roads" && showRoads) ||
//           (filter.type === "all" && allActive);

//         return (
//           <div
//             key={index}
//             className={`filter-item ${isActive ? "active" : ""}`}
//             onClick={() => {
//               if (filter.type === "landmarks") onLandmarksClick?.();
//               if (filter.type === "roads") onRoadsClick?.();

//               // ✅ لو ضغطنا على Show All
//               if (filter.type === "all") {
//                 if (!allActive) {
//                   // فعّلي الاتنين
//                   onLandmarksClick?.(true);
//                   onRoadsClick?.(true);
//                 } else {
//                   // اقفلي الاتنين
//                   onLandmarksClick?.(false);
//                   onRoadsClick?.(false);
//                 }
//               }
//             }}
//           >
//             {filter.icon && (
//               <img
//                 src={isActive ? filter.activeIcon : filter.icon}
//                 alt={filter.label}
//                 style={{ width: "20px", height: "20px" }}
//               />
//             )}
//             <p
//               className="m-0 p-0"
//               style={{
//                 color: isActive ? "white" : "#aaa",
//                 fontWeight: isActive ? "600" : "400",
//               }}
//             >
//               {filter.label}
//             </p>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// export default SideNav;














import React from "react";
import "./style/sidenav.css";
import { assets } from "../../../assets/assets";
import ar from "../../../lang/ar";
import en from "../../../lang/en";
function SideNav({
  lang,
  onLandmarksClick,
  onRoadsClick,
  onDevsClick,
  showPlaces,
  showRoads,
  isDevsActive,
}) {
  const translations = lang === "ar" ? ar : en;
 const allActive = showPlaces && showRoads && isDevsActive;

  const filters = [
    {
      icon: assets.showall,
      activeIcon: assets.showallActive,
      label: translations.showAll,
      type: "all",
    },
    {
      icon: assets.landmarks,
      activeIcon: assets.landmarksActive,
      label: translations.landmarks,
      type: "landmarks",
    },
    {
      icon: assets.roads,
      activeIcon: assets.roadsActive,
      label: translations.roads,
      type: "roads",
    },
    {
      icon: assets.building,
      activeIcon: assets.buildingActive,
      label: translations.developers,
      type: "devs",
    },
  ];

  return (
    <div
      className={`side-nav d-none d-md-flex ${
        lang === "ar" ? "right-side" : "left-side"
      }`}
    >
      <p className="title">{translations.mapFilter}</p>

      {filters.map((filter, index) => {
       const isActive =
  (filter.type === "landmarks" && showPlaces) ||
  (filter.type === "roads" && showRoads) ||
  (filter.type === "devs" && isDevsActive) ||
  (filter.type === "all" && allActive);

        return (
          <div
            key={index}
            className={`filter-item ${isActive ? "active" : ""}`}
            onClick={() => {
              if (filter.type === "landmarks") onLandmarksClick?.();
              if (filter.type === "roads") onRoadsClick?.();
              if (filter.type === "devs") onDevsClick?.(); // ✅ فعل الزر

              if (filter.type === "all") {
                if (!allActive) {
                  onLandmarksClick?.(true);
                  onRoadsClick?.(true);
                  onDevsClick?.(true); // ✅ include devs
                } else {
                  onLandmarksClick?.(false);
                  onRoadsClick?.(false);
                  onDevsClick?.(false); // ✅ include devs
                }
              }
            }}
          >
            {filter.icon && (
              <img
                src={isActive ? filter.activeIcon : filter.icon}
                alt={filter.label}
                style={{ width: "20px", height: "20px" }}
              />
            )}
            <p
              className="m-0 p-0"
              style={{
                color: isActive ? "white" : "#aaa",
                fontWeight: isActive ? "600" : "400",
              }}
            >
              {filter.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}


export default SideNav;